import { render, staticRenderFns } from "./BoxDemographicsGroupPie.vue?vue&type=template&id=2ef1ef6e&"
import script from "./BoxDemographicsGroupPie.vue?vue&type=script&lang=ts&"
export * from "./BoxDemographicsGroupPie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QIcon,QBtnToggle,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon,QBtnToggle,QCardSection})
